const INTEGRATION_ACTIVATION_MODAL_NAME = 'INTEGRATION_ACTIVATION_MODAL';

export default INTEGRATION_ACTIVATION_MODAL_NAME;
